import { useMemo } from "react";
import { useGetSchedules } from "../mutations";


const usePhaseData = ({ projectId, phaseId } : {projectId: number, phaseId: number | null}) => {

    const { data } = useGetSchedules(projectId);

    const phaseData = useMemo(() => {
        return data?.data?.rows
    }, [projectId]);

    const parentPhase = useMemo(() => {
        if (!phaseId || !phaseData) return null;
        return phaseData.find((row: any) => row.id === phaseId);
    }, [phaseId, phaseData]);

    return {
        phaseData: phaseData || [],
        parentPhase,
    }
};

export default usePhaseData;